import { useNavigate } from 'react-router-dom'

export const PALLET_DETAIL_URL =
  '/assembly/detail/:transferId/pallets/:container'

export const useGoToPalletDetail = () => {
  const navigate = useNavigate()

  return {
    go: (transferId: string, container: string) => {
      navigate(
        PALLET_DETAIL_URL.replace(':transferId', transferId).replace(
          ':container',
          container
        )
      )
    }
  }
}
